import React, { useEffect } from 'react'
import { useTranslate } from './TranslationText';
import { useState } from 'react';
import axiosInstance from '../axios/axios';

export default function AccessPermisions({ profile }) {
    const { translate } = useTranslate();
    const [permissions, setPermissions] = useState([]);
    async function getPermittions() {
        const res = await axiosInstance.get(`/account/getteamsaccesspermissions?ownerId=${profile?.value}`);
        if (res.status == 200) {
            if (res.data?.status?.responseCode == '200') {
                setPermissions(res.data?.result);
            }
        }
    }
    useEffect(() => {
        getPermittions();
    }, [profile])
    return (
        <>
            <div className={`col-lg-12 col-md-12 col-sm-12 mt-3 fw-bold text-start horseCardTitle mb-form-group`}  >
                {translate('web.teamsAccessPermissions', 'teamsAccessPermissions')}
            </div>
            {permissions.length > 0 ?
                <table className="table table-striped table-bordered rtl horseResultTable">
                    <thead className="theadHorseSelect">
                        <tr>
                            <th className="text-center">
                                {translate('web.ownerName', 'Owner Name')}
                            </th>
                            <th className="text-center">
                                {translate('web.permisions', 'Permisions')}
                            </th>

                            <th className="text-center">
                                {translate('web.status', 'Status')}
                            </th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        {permissions.map((item, index) => (
                            <tr>
                                <td>{item?.ownerName}</td>
                                <td>
                                    {item?.permissionsList?.length > 0 ? <>
                                        {item?.permissionsList.map((perm, _x) =>
                                        (<>
                                            {perm} {_x + 1 == item?.permissionsList.length ? "" : ', '}
                                        </>))}
                                    </> :
                                        <>
                                            {translate('web.noDataFound')}
                                        </>}
                                </td>
                                <td className={item?.isConfirmed ? 'text-success' : 'text-warning'} >
                                    {item?.isConfirmed ? translate('web.approved', 'Approved') : translate('web.pendingReview', 'Pending Review')}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table> :
                <div className={'p-main bg-white border-15 p-3 text-center'}>
                    {translate('web.noDataFound')}
                </div>
            }
        </>
    )
}
